import React from "react";
import { useHistory, useParams } from "react-router-dom";
import FooterMenu from "../../partials/FooterMenu";
import HeaderTopic from "../../partials/HeaderTopic";
import * as func from "../../utils/funcs";
import { addNewRound } from "../../api/addNewRound";
import { getRoundsLeague } from "../../api/getRoundsLeague";
import styles from "./AddRound.module.css";
import BasicButtons from "../../partials/BasicButtons";

function AddRound(props) {
  const { user, league, setRounds, refreshStates } = props;

  const [roundDate, setRoundDate] = React.useState(func.getCurrentDate());
  const [isClicked, setIsClicked] = React.useState(false);

  const { leagueId } = useParams();
  const history = useHistory();

   const handleSubmit = async () => {
     setIsClicked(true);
      const res = await addNewRound(leagueId, roundDate);
      const res2 = await getRoundsLeague(parseInt(leagueId, 10));
     setRounds(res2.data);
     history.push(`/leagues/${leagueId}/rounds/${res.data.id}`);
  };

  return (
    <div className={styles.addRound}>
      <HeaderTopic topic={"ליגת " + league.name} />
      <BasicButtons user={user} refreshStates={refreshStates} />
      <FooterMenu setActive="vs" />

      <div className="sectionTitleSize">מחזור חדש</div>

      <form className="paragraphSize">
        <div>
          <span>תאריך:</span>
          <input
            type="date"
            value={roundDate}
            onChange={(e) => setRoundDate(e.target.value)}
          />
        </div>
        <div
          className={`${"btnLarge"} ${styles.submitRound}`}
          onClick={handleSubmit}
          style={isClicked ? { display: "none" } : { display: "block" }}
        >
          יצירת מחזור חדש
        </div>
      </form>
    </div>
  );
}

export default AddRound;
